import './app/publicPath'

const Vue = window.Vue

Vue.component('LoseWidget', () => import('./app/loseWidget.vue'))
Vue.component('LoseAddItem', () => import('./app/loseAddItem.vue'))
Vue.component('LoseConfirmation', () => import('./app/loseConfirmation.vue'))
